export default "__VITE_ASSET__BO2VBHQ6__"